import React from 'react';
import styled from 'styled-components';
import { BorderColor } from 'styles/Global/colorSemantic';
import { zIndex } from 'styles/Global/globalStyles';
import { Body3Medium } from 'styles/Global/typography';

import IcBack from 'assets/Icons/Navigation/IcBack';
import { useNavigate } from 'react-router-dom';
import { IDDiagnosisNull } from 'models/DCK/basicInterface';
import { getDiagnosisStatus } from 'pages/DCK/utils';
import { mindupAdminMobilePaths } from 'constants/path';

const MindUpAdminMobileDetailDiagnosisHeader = ({ diagnosis }: { diagnosis?: IDDiagnosisNull }) => {
    const navigate = useNavigate();

    const handleBackButton = () => {
        if (getDiagnosisStatus(diagnosis!) === 'counselReserved' || getDiagnosisStatus(diagnosis!) === 'reschedule') {
            navigate(mindupAdminMobilePaths.mindUpAdminMobileUserReservationConsultation);
        } else if (getDiagnosisStatus(diagnosis!) === 'counselComplete') {
            navigate(mindupAdminMobilePaths.MindUpAdminMobileCompletedUserCounsel);
        } else {
            navigate(-1);
        }
    };

    return (
        <Layout>
            <ButtonWrapper onClick={handleBackButton}>
                <IcBack />
            </ButtonWrapper>
            상담 상세보기
        </Layout>
    );
};

export default MindUpAdminMobileDetailDiagnosisHeader;

const Layout = styled(Body3Medium)`
    position: fixed;
    self-align: center;
    top: 0;
    left: 50%; // 왼쪽에서 50% 위치로 이동
    transform: translateX(-50%);
    z-index: ${zIndex.floating};
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 360px;
    max-width: 576px;
    width: 100%;
    height: 56px;
    background-color: white;
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: linear-gradient(180deg, ${BorderColor.color_border_normal}, ${BorderColor.color_border_weak}, ${BorderColor.color_border_neutral});
    }
`;

const ButtonWrapper = styled.button`
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 100%;
`;
